import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import Gift from "./Gift";

export class CentralizedGifts extends Component {
  renderGifts = () => {
    const { currencySymbol, centralizedGifts, onFundAdded } = this.props;
    const content = [];

    if (centralizedGifts && centralizedGifts.size > 0) {
      centralizedGifts.map((centralizedGift, index) => {
        const currentKey = `${index}-${centralizedGift.get("name")}`;
        content.push(
          <Gift
            key={currentKey}
            currencySymbol={currencySymbol}
            centralizedGift={centralizedGift}
            onFundAdded={onFundAdded}
          />,
        );
      });
    }

    return content;
  };

  render() {
    return (
      <div className="centralized-gifts">
        <div className="centralized-gifts-title text-center">
          <div>
            <FormattedMessage id="beforeContinuePayment" />
          </div>
          <div>
            <FormattedMessage id="likeToDonateFunds" />
          </div>
        </div>
        <div className="centralized-gifts-list">{this.renderGifts()}</div>
      </div>
    );
  }
}

export default CentralizedGifts;
